import { useState } from 'react';
import Main from '../../../component/Main.jsx';
import HospitalVisitSelect from '../06_incurr_trms/HospitalVisitSelect.jsx';
import SearchBtn from '../../../component/common/button/SearchBtn.jsx';
import NewDataGrid from '../../../component/common/dataGrid/NewDataGrid.jsx';

const TrmsEmrt = () => {

    const [searchParams, setSearchParams] = useState({
        searchFromdate: new Date(new Date().getTime() - 1000 * 60 * 60 * 24 * 30 + 1000 * 60 * 60 * 9).toISOString().split('T')[0],
        searchTodate: new Date((new Date()).getTime() + 1000 * 60 * 60 * 9).toISOString().split('T')[0],
        searchEmog: '',
        searchIdno: '',
        searchGrdc: '',
        searchLoca: '',
        searchCheck1: '',
        searchCheck2: 'ALL',
    });

    const [desc, setDesc] = useState('');

    const searchParamsAdditional = { userAuth: localStorage.getItem("userAuth"), };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        const newParams = {
            ...searchParams,
            [name]: value
        };
        setSearchParams(newParams);
    };

    const dataHead = [['기관명', 'ISS', '전체', '가망없는 퇴실', '전원', '전원', '전원', '전원', '전원', '전원', '전원', '전원', '전원', '전원', '입원', '입원', '입원', '입원', '입원', '입원', '사망', '사망', '사망', '사망', '사망', '사망', '사망'], ['기관명', 'ISS', '전체', '가망없는 퇴실', '소계', '병실부족 전원', '중환자실 부족', '응급수술·처치불가', '전문 응급의료 요함', '경증', '요양병원 전원', '환자 OR 보호자 사정', '회송', '기타', '소계', '일반병실', '중환자실', '수술(시술)후 병실', '수술(시술)후 중환자실', '기타', '소계', '치료대상이 되지않는 DOA', '내원시 심정지,응급실 CPR 미시행', '내원시 심정지,응급실 CPR 시행', '내원시 생존,CPR 시행', '내원시 생존,CPR 미시행', '기타']]; //component화 
    const dataColumn = ['TRMSEMNM', 'ISS_DIV', 'EMRT_TOTAL', 'ERMT13_CNT', 'EMRT21_29_CNT', 'EMRT21_CNT', 'EMRT22_CNT', 'EMRT23_CNT', 'EMRT24_CNT', 'EMRT25_CNT', 'EMRT26_CNT', 'EMRT27_CNT', 'EMRT29_CNT', 'EMRT28_CNT', 'EMRT31_39_CNT', 'EMRT31_CNT', 'EMRT32_CNT', 'EMRT33_CNT', 'EMRT34_CNT', 'EMRT38_CNT', 'EMRT41_49_CNT', 'EMRT41_CNT', 'EMRT42_CNT', 'EMRT43_CNT', 'EMRT44_CNT', 'EMRT45_CNT', 'EMRT48_CNT'];
    const apiCall = '/trmsapi/trtinfo/bdtongtrms_stat_emrt_search.do';
    const apiCntCall = '';
    const excelFileName = `${desc || '전체'}_응급진료결과 현황`;
    const excelHead = ['기관명', 'ISS', '전체', '가망없는 퇴실', '소계(전원)', '병실부족 전원(전원)', '중환자실 부족(전원)', '응급수술·처치불가(전원)', '전문 응급의료 요함(전원)', '경증(전원)', '요양병원 전원(전원)', '환자 OR 보호자 사정(전원)', '회송(전원)', '기타(전원)', '소계(입원)', '일반병실(입원)', '중환자실(입원)', '수술(시술)후 병실(입원)', '수술(시술)후 중환자실(입원)', '기타(입원)', '소계(사망)', '치료대상이 되지않는 DOA(사망)', '내원시 심정지,응급실 CPR 미시행(사망)', '내원시 심정지,응급실 CPR 시행(사망)', '내원시 생존,CPR 시행(사망)', '내원시 생존,CPR 미시행(사망)', '기타(사망)'];
    const mergeConfig = [{ key: 'TRMSEMNM', row: null }];

    const propsInfo = {
        dataHead: dataHead,
        dataColumn: dataColumn,
        apiCall: apiCall,
        apiCntCall: apiCntCall,
        excelFileName: excelFileName,
        excelHead: excelHead
    }

    const [state, setState] = useState({
        dataList: [],
        isSearched: false,
        isLoading: false
    })

    const [pageInfo, setPageInfo] = useState({
        paginationTF: false,
        currentPage: 1,
        itemsPerPage: 50, // 한 페이지당 보여줄 데이터 수
        totalItems: 0 // 전체 데이터 수
    });

    return (
        <Main>
            <div className="com-search">
                <table>
                    <colgroup>
                        <col width="10%" />
                        <col width="24%" />
                        <col width="10%" />
                        <col width="18%" />
                        <col width="10%" />
                        <col width="18%" />
                    </colgroup>
                    <tbody>
                        <tr>
                            <HospitalVisitSelect
                                searchParams={searchParams}
                                handleInputChange={handleInputChange}
                                setDesc={setDesc}
                            />
                        </tr>
                        <tr>
                            <th>환자분류</th>
                            <td>
                                <select id="searchCheck1"
                                    name="searchCheck1"
                                    value={searchParams.searchCheck1}
                                    onChange={handleInputChange}
                                >
                                    <option value="">전체</option>
                                    <option value="2">응급센터</option>
                                    <option value="1">외상센터</option>
                                </select>
                            </td>
                            <th>성별</th>
                            <td>
                                <select id="searchCheck2"
                                    name="searchCheck2"
                                    value={searchParams.searchCheck2}
                                    onChange={handleInputChange}
                                >
                                    <option value="ALL">전체</option>
                                    <option value="M">남자</option>
                                    <option value="F">여자</option>
                                </select>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <SearchBtn
                propsInfo={propsInfo}
                state={state}
                setState={setState}
                searchParams={searchParams}
                searchParamsAdditional={searchParamsAdditional}
                pageInfo={pageInfo}
                setPageInfo={setPageInfo}
                mergeConfig={mergeConfig}
            />
            <NewDataGrid
                propsInfo={propsInfo}
                state={state}
                pageInfo={pageInfo}
                setPageInfo={setPageInfo}
                mergeConfig={mergeConfig}
            />
            <p> * 외상등록체계 전송 대상자 중 ‘외상환자 제외’ 및 ‘연동 후 제외’, ‘외상 삭제’ 제외 </p>
        </Main>
    )
}

export default TrmsEmrt;